import * as React from 'react';

import classNames from 'classnames';

import CharacterCount from 'bundles/author-common/components/CharacterCount';
import CharacterLimitError from 'bundles/author-common/components/CharacterLimitError';
import EditHelpMessage from 'bundles/teach-course/components/EditHelpMessage';

import 'css!./__styles__/TextInputEditor';

type Props = {
  onChange: (value: string, valid: boolean) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  helpMessage?: string | React.ReactElement;
  disabled: boolean;
  minLength?: number;
  maxLength?: number;
  autoFocus: boolean;
  readOnly: boolean;
  submissionFailed?: boolean;
};

type State = {
  count: number;
};

class TextInputEditor extends React.Component<Props, State> {
  static defaultProps = {
    disabled: false,
    autoFocus: false,
    readOnly: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      count: props.defaultValue ? props.defaultValue.length : 0,
    };
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const { minLength, maxLength, onChange } = this.props;

    let valid = true;
    if (minLength && maxLength) {
      valid = value.length >= minLength && value.length <= maxLength;
    } else if (maxLength) {
      valid = value.length <= maxLength;
    }

    onChange(value, valid);

    this.setState({
      count: value.length,
    });
  };

  renderEnabled() {
    const {
      defaultValue,
      placeholder,
      minLength,
      maxLength,
      helpMessage,
      autoFocus,
      value,
      readOnly,
      onKeyDown,
      submissionFailed,
      onFocus,
    } = this.props;
    const { count } = this.state;
    const configClass = classNames('c-input', {
      'c-input-error': submissionFailed,
    });
    return (
      <div>
        <input
          type="text"
          className={configClass}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          readOnly={readOnly}
          onChange={this.handleChange}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
        />

        {maxLength && <CharacterCount count={count} limit={maxLength} />}
        {maxLength && minLength && <CharacterLimitError count={count} min={minLength} max={maxLength} />}

        {helpMessage && <EditHelpMessage>{helpMessage}</EditHelpMessage>}
      </div>
    );
  }

  render() {
    const { disabled, defaultValue, value, readOnly } = this.props;
    const configClasses = classNames('rc-TextInputEditor', {
      'rc-TextInputEditor-readonly': readOnly,
    });

    return (
      <div className={configClasses}>
        {!disabled && this.renderEnabled()}
        {(disabled && defaultValue) || (!readOnly && value)}
      </div>
    );
  }
}

export default TextInputEditor;
